import Head from "next/head";
import { wrapper } from "@/redux/Store";

import CommunityGuidelinesPage from "@/containers/StaticPages/Community/GuidelinesPage";
import { renderMetaData } from "@/utils";
const CommunityGuidelines = () => {
  const metaData = {
    title: "Communities guidelines",
    description: "Communities guidelines",
  };

  const metaTags = renderMetaData(metaData);
  return (
    <>
      {metaTags}
      <main>
        <CommunityGuidelinesPage />
      </main>
    </>
  );
};

export default CommunityGuidelines;

export const getStaticProps = wrapper.getStaticProps(() => async () => {
  return {
    props: {},
    revalidate: 60 * 60 * 24 * 15, // revalidate in 15 days
  };
});
